var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#3A8CBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57687 10.1504H8.52074C8.79044 10.1513 9.05695 10.0921 9.30093 9.97718C9.53155 9.86299 9.73743 9.70493 9.90674 9.51143C10.0749 9.31118 10.2049 9.08224 10.2915 8.83587C10.3848 8.58619 10.4321 8.32166 10.431 8.05512C10.4325 7.79503 10.3808 7.53738 10.2791 7.29799C10.1816 7.05547 10.0439 6.83108 9.87187 6.63424C9.69851 6.43707 9.48882 6.27513 9.25424 6.15724C9.01368 6.0329 8.74653 5.96881 8.47574 5.97049H5.99512V11.9909H7.57912L7.57687 10.1504ZM7.57687 7.42455H8.37955C8.49112 7.43188 8.59552 7.48207 8.67093 7.56462C8.7643 7.65743 8.8228 7.82112 8.8228 8.07705C8.8228 8.33299 8.76487 8.48487 8.68218 8.56755C8.61299 8.64912 8.51962 8.70705 8.41499 8.70705H7.57687V7.42455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95044 4.51695V13.4539C3.95044 13.7746 4.20975 14.0333 4.52981 14.0333H13.4668C13.7869 14.0333 14.0462 13.7746 14.0462 13.4539V4.51695C14.0463 4.44082 14.0313 4.36542 14.0022 4.29506C13.9732 4.2247 13.9305 4.16077 13.8767 4.10691C13.8229 4.05305 13.759 4.01032 13.6887 3.98117C13.6183 3.95202 13.5429 3.93701 13.4668 3.93701H4.52981C4.45373 3.93701 4.37839 3.952 4.3081 3.98111C4.2378 4.01023 4.17393 4.05291 4.12013 4.10671C4.06633 4.16051 4.02366 4.22438 3.99454 4.29467C3.96543 4.36496 3.95044 4.44086 3.95044 4.51695ZM12.2771 12.8442H5.70713C5.631 12.8443 5.55559 12.8293 5.48524 12.8003C5.41488 12.7712 5.35094 12.7285 5.29708 12.6747C5.24322 12.6209 5.2005 12.557 5.17135 12.4867C5.14219 12.4163 5.12719 12.341 5.12719 12.2648V5.69482C5.12712 5.61864 5.14207 5.5432 5.17118 5.4728C5.2003 5.40241 5.24302 5.33845 5.29688 5.28458C5.35075 5.23071 5.41471 5.188 5.48511 5.15888C5.5555 5.12976 5.63095 5.11481 5.70713 5.11489H12.2771C12.5978 5.11489 12.8565 5.3742 12.8565 5.69426V12.2643C12.8565 12.5849 12.5978 12.8442 12.2771 12.8442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28732 10.8613H12.0038V12.0032H8.28732V10.8613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPre);
export default __webpack_public_path__ + "static/media/pre.c019e7ea1176c33c3451748163bb6199.svg";
export { ForwardRef as ReactComponent };